import React, { useState } from 'react';
import useValidation from 'hooks/useValidation';
import services from 'services/services';

const selectorText = (evt) => {
  if (evt) {
    return evt.target.value.trim();
  }

  return null;
};

const validatorRequired = (label) => {
  return (value) => {
    if (!value) {
      return `${label} is required`;
    }

    return null;
  };
};

const validatorMaxChars = (label, maxChars) => {
  return (value) => {
    if (value.length > maxChars) {
        return `${label} must not exceed ${maxChars} characters`;
    }

    return null;
  };
};

const validatorEmail = () => {
  return (value) => {
    if ((value.match(/@/g) || []).length !== 1) {
        return 'Email format is invalid';
      }
    
      return null;
  };
};

const validators = (args) => {
  return (value) => {
      return args.reduce((currError, currArg) => {
        if (!currError) {
            return currArg(value);
        }

        return currError;
      }, null);
  };
};

const PartnershipForm = ({ onSuccess = ()=>{}, onError = ()=>{} }) => {
  const [ onChangeEmail, email ] = 
      useValidation(selectorText,
        validators([
          validatorRequired('Email'),
          validatorEmail(),
          validatorMaxChars('Email', 64),
        ]));
        
  const [ onChangeFirstName, firstName ] = 
      useValidation(selectorText, 
        validators([
          validatorRequired('First name'),
          validatorMaxChars('First name', 40),
        ]));

  const [ onChangeLastName, lastName ] =
        useValidation(selectorText,
          validators([
            validatorRequired('Last name'),
            validatorMaxChars('Last name', 25),
          ]));

  const [ onChangeCompany, company ] =
        useValidation(selectorText, 
          validators([
            validatorRequired('Company'),
            validatorMaxChars('Company', 80),
          ]));

  const getCompleteClassName = (prop, errorClass, defaultClass) => {
    if (hasValidationError(prop)) {
      return `${defaultClass} ${errorClass}`;
    }
  
    return defaultClass;
  };

  const hasValidationError = (prop) => {
    return (prop.dirty || isSubmitted) && prop.error;
  };

  const getErrorMessage = (prop) => {
    if (hasValidationError(prop)) {
      return <div className="mce_inline_error">{ prop.error }</div>
    }
  
    return <></>;
  };

  const [ isSubmitted, setSubmitted ] = useState(false);
  const [ isLoading, setLoading ] = useState(false);

  const onFormSubmit = (evt) => {
    evt.preventDefault();

    if (firstName.error
          || lastName.error
          || email.error 
          || company.error) {
      setSubmitted(true);
      return;
    }

    setLoading(true);

    try {
      let payload = {
        firstName: firstName.value,
        lastName: lastName.value,
        email: email.value,
        company: company.value,
      };

      services.partnership(payload).then(({ data }) => {
        if (data.status === 'success') {
          onSuccess(data);
        } else {
          onError(data);
        }
      }).catch((error) => {
        onError(error);
      })
    } catch (error) {
      onError(error);
    }
  };

  return (
    <>
      <div id="mc_embed_signup">
        <form method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate p-0" noValidate onSubmit={ onFormSubmit }>
          <div id="mc_embed_signup_scroll">
            <div className="indicates-required"><span className="asterisk">*</span> indicates required</div>

            <div className="mc-field-group">
              <label htmlFor="mce-EMAIL">Email Address  <span className="asterisk">*</span></label>
              <input
                  type="email" 
                  defaultValue="" 
                  name="EMAIL" 
                  placeholder="Email"
                  disabled={ isLoading }
                  className={ getCompleteClassName(email, 'mce_inline_error', 'required email') }
                  id="mce-EMAIL"
                  onChange={ onChangeEmail } />
              { getErrorMessage(email) }
            </div>
            <div className="mc-field-group">
              <label htmlFor="mce-FNAME">First Name  <span className="asterisk">*</span></label>
              <input 
                  type="text" 
                  defaultValue="" 
                  name="FNAME" 
                  placeholder="First name" 
                  disabled={ isLoading }
                  className={ getCompleteClassName(firstName, 'mce_inline_error', 'required') } 
                  id="mce-FNAME"
                  onChange={ onChangeFirstName } />
              { getErrorMessage(firstName) }
            </div>
            <div className="mc-field-group">
              <label htmlFor="mce-LNAME">Last Name  <span className="asterisk">*</span></label>
              <input 
                  type="text" 
                  defaultValue="" 
                  name="LNAME"
                  placeholder="Last name"
                  disabled={ isLoading } 
                  className={ getCompleteClassName(lastName, 'mce_inline_error', 'required') } 
                  id="mce-LNAME"
                  onChange={ onChangeLastName } />
              { getErrorMessage(lastName) }
            </div>
            <div className="mc-field-group">
              <label htmlFor="mce-COMPANY">Company  <span className="asterisk">*</span></label>
              <input 
                  type="text" 
                  defaultValue="" 
                  name="COMPANY" 
                  placeholder="Company" 
                  disabled={ isLoading }
                  className={ getCompleteClassName(company, 'mce_inline_error', 'required' )} 
                  id="mce-COMPANY"
                  onChange={ onChangeCompany } />
              { getErrorMessage(company) }
            </div>
            <div className="clear">
              <input type="submit" value="Submit" name="subscribe" id="mc-embedded-subscribe" className="button btn btn-lg btn-warning"  disabled={ isLoading } />
            </div>
          </div>
        </form>
      </div>
    </>
  )
};

export default PartnershipForm;